/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2021 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

import { call, put, select, takeLatest } from 'redux-saga/effects';

import { selectInitedStateful } from '../../common/sagas';
import { sessionDeleteErrorMultiple, sessionDeleteErrorSingle, sessionDeleteSuccessMultiple, sessionDeleteSuccessSingle } from '../../ui/toast.list';
import * as T from '../actions';
import { sessionsTable } from '../data/table.prefabs';

export function* deleteSession() {
  const selectedData = yield select(sessionsTable.selectedData);
  const stateful = yield call(selectInitedStateful);

  let deleteError = false;
  for (let i = 0; i < selectedData.length; i++) {
    try {
      const results = yield call([stateful, 'deleteSession'], { uuid: selectedData[i].uuid });
      if (!results) {
        throw new Error('Error deleting the session.');
      }
      yield put(sessionsTable.deselectRowsAction(selectedData[i]));
    } catch (err) {
      deleteError = true;
    }
  }
  if (deleteError) {
    if (selectedData.length === 1) {
      yield put(sessionDeleteErrorSingle);
    } else {
      yield put(sessionDeleteErrorMultiple);
    }
  } else if (selectedData.length === 1) {
    yield put(sessionDeleteSuccessSingle);
  } else {
    yield put(sessionDeleteSuccessMultiple);
  }
  yield put(T.searchSessions({ force: true }));
}

export default function* watchDeleteSession() {
  yield takeLatest(T.DELETE_SESSION, deleteSession);
}
